module.exports = __webpack_public_path__ + "static/media/exportLogo.147d2ca8.svg";